export default "__VITE_ASSET__nCzr3l7g__"